<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="px-10 pt-4"><h2>{{ title }}</h2></v-card-title>
      <v-main class="pa-0 px-12 mb-10">
          <v-text-field label="Titel der Umfrage" v-model="inputText"></v-text-field>
      </v-main>
      <v-card-actions class="bg-gray pr-6 pb-6">
        <v-btn id="leftButton" text @click.stop="cancel">Abbrechen</v-btn>
        <v-btn id="rightButton" @click.stop="agree" color="primary" elevation="0">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FormDlg",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      inputText: "",
      title: null,
      options: {
        width: 600,
        zIndex: 200,
      }
    };
  },

  methods: {
    open(title, options) {
      this.dialog = true;
      this.title = title;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(this.inputText);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    }
  }
};
</script>